import React from 'react';
import { useNavigate } from 'react-router-dom';
import { quote } from '../mock';

const Quote = () => {
  const navigate = useNavigate();

  const handleBookAppointment = () => {
    navigate('/contact#contact-form');
  };

  return (
    <section className="py-20 bg-gray-900 text-white">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto text-center">
          <div className="mb-6">
            <svg className="w-16 h-16 mx-auto text-red-600" fill="currentColor" viewBox="0 0 24 24">
              <path d="M6 17h3l2-4V7H5v6h3zm8 0h3l2-4V7h-6v6h3z" />
            </svg>
          </div>
          <blockquote className="text-2xl md:text-3xl lg:text-4xl font-bold mb-6 leading-relaxed">
            {quote.text}
          </blockquote>
          <cite className="text-lg text-gray-400 not-italic">
            - {quote.author}
          </cite>
          <div className="mt-10">
            <button 
              onClick={handleBookAppointment}
              className="bg-red-600 text-white px-8 py-3 rounded-md hover:bg-red-700 transition-all font-medium"
            >
              Book An Appointment With Us
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Quote;
